export default __webpack_public_path__ + "static/media/road_img_6_6.3655d209.jpg";